import React from 'react';

// Images
import AppStoreBadge from '@zola/zola-ui/src/assets/images/footer/app-store-badge.svg';

// Styles
import styles from './MobileAppBadges.module.less';

const MobileAppBadges: React.FC = () => {
  return (
    <div>
      <a
        href="https://itunes.apple.com/us/app/zola-wedding-registry-gifts/id852691916"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.mobileAppBadge}
      >
        <img
          className={styles.mobileAppBadgeImg}
          src={AppStoreBadge}
          alt="Download on the App Store"
        />
      </a>
    </div>
  );
};

export default MobileAppBadges;
